import { ITextConvertModule } from '@leafer-ui/interface'

import { getDrawData } from './TextConvert'

export const TextConvertModule: ITextConvertModule = {
    getDrawData
}